module.exports = __webpack_public_path__ + "static/media/quiz-winner.737a9dd0.jpg";